<template lang="html">
  <NumericResultBase :value="result ? result.relativeEmissions : null">
    <slot />

    <template #unit>
      kg CO₂e
    </template>
  </NumericResultBase>
</template>

<script>
import NumericResultBase from './NumericResultBase'

export default {
  components: {
    NumericResultBase
  },
  props: {
    result: Object
  }
}
</script>

<style lang="scss" module>
</style>
